export default httpClient => ({
  save: async ({ formImagens, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
    const response = await httpClient.post('/imagens-clinicas', formImagens, { headers });
    return {
      data: response.data,
    }
  },
  delete: async ({ imagens, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/deletar-imagens-clinicas',{imagens}, { headers });
    return {
      data: response
    }
  },
});